export default __webpack_public_path__ + "static/media/Group_static_refe.dd41b93f.svg";